import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import * as fromActions from './dealer.actions';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { IDealerInfo, IResponse } from '@signal/asp-data-commons';
import { SettingsService } from '../../shared/services/settings.service';
import { StateDetails } from '../../shared/models/state';

@Injectable({
  providedIn: 'root'
})
export class DealerEffects {

  
  LoadDealerDetails: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.LoadDealerDetails>(
      fromActions.DealerTypes.LOAD_DEALER_DETAILS
    ),
    mergeMap((action: fromActions.LoadDealerDetails) =>
      this.settingsService.getAllSettings(action.payload.dealerCode).pipe(
        map((dealerInfo: IResponse<IDealerInfo>) =>
          new fromActions.LoadDealerDetailsSuccess({ dealerInfo: dealerInfo.data })),
        catchError(err => of(new fromActions.LoadDealerDetailsFail({ error: err })))
      ))));

  
  loadStates: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.LoadStatesDetails>(
      fromActions.DealerTypes.LOAD_STATES
    ),
    mergeMap((action: fromActions.LoadStatesDetails) =>
      this.settingsService.getStates().pipe(
        map((states: StateDetails[]) =>
          new fromActions.LoadStatesDetailsSuccess({ states })),
        catchError(err => of(new fromActions.LoadStatesDetailsFail({ error: err })))
      ))));
      
      loaddashboardcontents: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadOverlayDashboardContents>(
          fromActions.DealerTypes.LOAD_DASHBOARD_CONTENTS
        ),
        mergeMap((action: fromActions.LoadOverlayDashboardContents) =>
          this.settingsService.getDashboardContents().pipe(
            map((contents: any[]) =>
              new fromActions.LoadDashboardOverlayContentsSuccess({ contents })),
            catchError(err => of(new fromActions.LoadDashboardOverlayContentsFailure({ error: err })))
      ))));
  
  loadCities: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.LoadCityDetails>(
      fromActions.DealerTypes.LOAD_CITIES
    ),
    mergeMap((action: fromActions.LoadCityDetails) =>
      this.settingsService.getCities().pipe(
        map((cities: { [key: string]: string[] }) =>
          new fromActions.LoadCityDetailsSuccess({ cities })),
        catchError(err => of(new fromActions.LoadCityDetailsFail({ error: err })))
      ))));

  constructor(private actions$: Actions,
    private settingsService: SettingsService) { }
}
